module.exports = __webpack_public_path__ + "img/cart-active.f38dc3dd.svg";